import { isAdmin } from 'permissions/v1/roles';
import {
  canList,
  canView,
  canCreate,
  canUpdate,
  canDestroy,
  noPermissions,
} from 'permissions/v1/index';
import { hasLanes, hasActionRequests } from 'permissions/v1/preferences';

const permission = 'CardTemplate';

const list = (profile) => isAdmin(profile) || canList(permission, profile);
const view = (profile) => isAdmin(profile) || canView(permission, profile);
const create = (profile) => isAdmin(profile) || canCreate(permission, profile);
const update = (profile) => isAdmin(profile) || canUpdate(permission, profile);
const destroy = (profile) => isAdmin(profile) || canDestroy(permission, profile);

const permissions = (profile) => {
  if (!hasActionRequests(profile)) return noPermissions;

  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
    // This is actually unusual, in general we will actually incoroporate a preference into each list/view/create/update permissoin itself
    // but that is because we usually preference entire features and not just subsets of functionality like this.
    customStatus: hasLanes(profile),
  };
};

export default permissions;
